import React from 'react';
import {Box, Typography} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';
import {ArrowForwardOutlined} from '@mui/icons-material';
import {useGetList, usePermissions, useTranslate} from 'react-admin';
import {t} from '../themes/statamicTokens';
import PostCard from '../posts/PostCard';
import {SkeletonCard} from '../components/statamic/Skeleton';
import EmptyState from '../components/statamic/EmptyState';

const NewPosts = ({umbrellaId, charityId}) => {
    const translate = useTranslate();
    const {permissions} = usePermissions();
    const canSeeStatus = permissions === 'admin' || permissions === 'umbrella';

    const filter = {};
    if (charityId) filter.charity_id = charityId;
    if (umbrellaId) filter.umbrella_id = umbrellaId;

    const {data: posts, isLoading} = useGetList(
        'posts',
        {
            sort: {field: 'id', order: 'DESC'},
            pagination: {page: 1, perPage: 8},
            filter,
        },
    );

    return (
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 2}}>
            {isLoading && (
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                        gap: 2,
                    }}
                >
                    {Array.from({length: 4}).map((_, i) => <SkeletonCard key={i}/>)}
                </Box>
            )}

            {!isLoading && (!posts || posts.length === 0) && (
                <EmptyState
                    title={translate('No posts yet')}
                    description={translate('New posts shared by volunteers will appear here.')}
                    dense
                />
            )}

            {!isLoading && posts && posts.length > 0 && (
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
                        gap: 2,
                    }}
                >
                    {posts.map((post) => (
                        <PostCard
                            key={post.id}
                            post={post}
                            showStatus={canSeeStatus}
                        />
                    ))}
                </Box>
            )}

            {!isLoading && posts && posts.length > 0 && (
                <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
                    <Box
                        component={RouterLink}
                        to="/posts"
                        sx={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 0.5,
                            fontSize: `${t.type.small.size}px`,
                            color: t.color.accent.primary,
                            fontWeight: 500,
                            textDecoration: 'none',
                            '&:hover': {textDecoration: 'underline'},
                        }}
                    >
                        <Typography sx={{fontSize: 'inherit'}}>
                            {translate('Show all posts')}
                        </Typography>
                        <ArrowForwardOutlined sx={{fontSize: 14}}/>
                    </Box>
                </Box>
            )}
        </Box>
    );
};

export default NewPosts;
